










































import Down from '@/uikit/components/AppSvgIconNew/templates/icons/down.vue';
import Arrow_up from '@/uikit/components/AppSvgIconNew/templates/icons/arrow_up.vue';
import Apply from '@/uikit/components/AppSvgIconNew/templates/icons/apply.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
import { createGuid } from '@/uikit/utils/guide';
export default {
  name: 'AppComboboxSingle',
  components: { Apply, Arrow_up, Down, AppSvgIcon },
  props: {
    notEmpty: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isEnableSort: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    filterable: {
      type: [Boolean, String],
      default: false,
      validator: (value: any) => typeof value === 'boolean' || value === 'auto',
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: undefined,
    },
    checkForm: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    checkForm(value: any) {
      if (value) {
        this.checkError();
      }
    },
    value(value: any) {
      this.selectedValue = value;
    },
  },
  data() {
    return {
      selectedValue: this.selected,
      open: false,
      id: createGuid(),
      search: '',
      thisInput: 'thisInput',
      isError: false,
      isToTop: false,
    };
  },
  created() {
    this.selectedValue = this.value;
    this.sortData();
  },
  computed: {
    selected: {
      get() {
        return this.selectedValue || '';
      },
      set(value: any) {
        this.selectedValue = value;
      },
    },
    checkAllError() {
      // console.log(this.valid);
      if (this.valid !== undefined) {
        if (this.valid === null) {
          return false;
        }
        return !this.valid;
      }
      return this.isError || this.error;
    },
    getText() {
      return this.selected
        ? this.data.find((el: any) => el.id === this.selected)?.text
        : '';
    },
    getSelectedData() {
      return this.search
        ? this.data.filter((el: any) => {
            return el.text
              .toLowerCase()
              .includes(this.search.trim().toLowerCase());
          })
        : this.data;
    },
    getStyle() {
      let getBorder = () => {
        if (this.open) {
          return '1px solid #279DF2';
        } else if (this.checkAllError) {
          return '1px solid #F01F51';
        } else {
          return '1px solid #B6B6B6';
        }
      };
      return {
        '--ui_combobox_border': getBorder(),
      };
    },
  },
  mounted() {
    if (document) {
      let _id = this.id;
      document.addEventListener('click', (event: any) => {
        for (const pathElement of event.composedPath()) {
          if (pathElement.id === _id) {
            return;
          }
        }
        this.open = false;
      });
    }
    // window.innerHeight - this.$refs.combobox.getBoundingClientRect().bottom
  },
  methods: {
    calculateTop() {
      this.isToTop = !!(
        typeof window !== 'undefined' &&
        this.$refs?.combobox &&
        window.innerHeight -
          this.$refs.combobox.getBoundingClientRect().bottom <
          210
      );
    },
    selectData(data: any) {
      this.$emit('input', data.id);
      this.selected = data.id;
      this.checkError();
      this.toggle();
      this.sortData();
    },
    checkError() {
      if (this.notEmpty) {
        this.isError = !this.selected;
        this.$emit('validate', !this.isError);
      }
    },
    toggle() {
      this.calculateTop();
      this.open = !this.open;
      if (this.open && this.filterable) {
        this.$nextTick(() => {
          this.$refs[this.thisInput]?.focus();
        });
      }
    },
    sortData() {
      if (this.isEnableSort)
        this.data.sort((el1: any, el2: any) => {
          if (el1.id === this.selected && el2.id !== this.selected) {
            return -1;
          } else if (el1.id !== this.selected && el2.id === this.selected) {
            return 1;
          } else {
            return 0;
          }
        });
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppComboBox/AppComboboxSingle.vue